export default "__VITE_ASSET__54b1bb33__"